import React, { useEffect, useState } from "react";
import { Empty, Spin, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { httpService } from "../../../../services/httpService.service";
import { getSiteVisitStatus } from "../../../../services/Enums/siteVisitStatusEnum";
import { formatDate } from "../../../../services/helpFunctions/formatDateAndTime";
import StalledPill from "../../../components/StalledPill/StalledPill";

// Near-term planned site visits (this week + next), sorted by planned date.
// Useful for Field Coordinators planning their workload.
const UpcomingVisitsPanel = () => {
  const navigate = useNavigate();
  const projectID = localStorage.getItem("currentProjectID");
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectID) {
      setLoading(false);
      return;
    }
    const statusParams = [2, 3, 4, 5, 6]
      .map((s) => `SiteVisitStatus=${s}`)
      .join("&");
    httpService.get(
      `/api/Site/getAllSiteVisits?ProjectId=${projectID}&IgnorePagination=true&${statusParams}`,
      (res) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const horizon = new Date(today);
        horizon.setDate(horizon.getDate() + 14); // this week + next

        const upcoming = (res?.data || [])
          .filter((v) => {
            const d = v?.visit?.plannedVisit ? new Date(v.visit.plannedVisit) : null;
            return d && !isNaN(d.getTime()) && d >= today && d <= horizon;
          })
          .sort(
            (a, b) =>
              new Date(a.visit.plannedVisit).getTime() -
              new Date(b.visit.plannedVisit).getTime()
          )
          .slice(0, 8);

        setVisits(upcoming);
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [projectID]);

  if (loading) {
    return (
      <div className="homePanel">
        <div className="homePanelLoading">
          <Spin />
        </div>
      </div>
    );
  }

  return (
    <div className="homePanel">
      <div className="homePanelHead">
        <h3>Upcoming visits</h3>
        <span className="homePanelLink" onClick={() => navigate("/project/planning?visits")}>
          View all
        </span>
      </div>
      {visits.length === 0 ? (
        <Empty description="No visits planned in the next two weeks" />
      ) : (
        <div className="homeListRows">
          {visits.map((v) => {
            const status = getSiteVisitStatus(v?.siteVisitStatus);
            return (
              <div
                className="homeListRow"
                key={v.id}
                onClick={() => navigate("/project/planning?visits")}
              >
                <div className="homeListRowMain">
                  <span className="homeListRowTitle">
                    {v?.name || v?.identifier || "Site visit"}
                  </span>
                  <span className="homeListRowSub">
                    {v?.ipPlan?.implementingPartner?.name || ""}
                  </span>
                </div>
                <div className="homeListRowSide">
                  {/* F-03 — stalled badge (visibility only, no data change).
                      Shared pill so every visit surface marks stalled the same
                      way. */}
                  {v?.isStalled && <StalledPill stalledSince={v?.stalledSince} />}
                  <Tag>{formatDate(v.visit.plannedVisit)}</Tag>
                  <span className="homeStatusDot">
                    <svg width="8" height="8" viewBox="0 0 9 9">
                      <circle cx="4.5" cy="4.27" r="4" fill={status.fill} />
                    </svg>
                    {status.text}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default UpcomingVisitsPanel;
